import withTabs from "../../conteiners/tabs/Tabs.hoc";

const WarehouseSettings = () => {
  return <div>WarehouseSettings</div>;
};

export default withTabs({label: "Warehouse Settings"})(WarehouseSettings);
